import React from "react";

import { longDate } from "../../utils/DateHelper";
import { DATES_CONSTANTS } from "../../utils/constants";
import { Trans, useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

const FilterTags = ({
    filterOptions,
    appliedFilters,
    handleCloseTag,
    selectedFilters,
}) => {
    const { t } = useTranslation();

    const returnDatesFromFilters = (option) => {
        const startDateValue = appliedFilters[option.name].startDate
            ? longDate(appliedFilters[option.name].startDate)
            : null;

        const endDateValue = appliedFilters[option.name].endDate
            ? longDate(appliedFilters[option.name].endDate)
            : null;

        return { startDateValue, endDateValue };
    };

    const hideDateTag = (condition) => {
        return condition ? "" : "hidden";
    };

    const renderFilterTags = () => {
        const renderDateOption = (option, index) => {
            let startDateValue, endDateValue;
            ({ startDateValue, endDateValue } = returnDatesFromFilters(option));
            return (
                <React.Fragment key={index}>
                    {startDateValue && (
                        <li
                            key={`${index}-startDate`}
                            className={`tags-items ${hideDateTag(
                                appliedFilters &&
                                    appliedFilters[option.name][
                                        DATES_CONSTANTS.startDate
                                    ]
                            )}`}
                        >
                            <span className="font-semibold mr-1">
                                <Trans i18nKey="startDate">Start Date</Trans>:
                            </span>
                            <span>{startDateValue}</span>

                            <i
                                onClick={() =>
                                    handleCloseTag(
                                        option.name,
                                        DATES_CONSTANTS.startDate,
                                        true
                                    )
                                }
                                className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                            ></i>
                        </li>
                    )}

                    {endDateValue && (
                        <li
                            key={`${index}-endDate`}
                            className={`tags-items ${hideDateTag(
                                appliedFilters &&
                                    appliedFilters[option.name][
                                        DATES_CONSTANTS.endDate
                                    ]
                            )}`}
                        >
                            <span className="font-semibold mr-1">
                                <Trans i18nKey="endDate">End Date</Trans>:
                            </span>
                            <span>{endDateValue}</span>
                            <i
                                onClick={() =>
                                    handleCloseTag(
                                        option.name,
                                        DATES_CONSTANTS.endDate,
                                        true
                                    )
                                }
                                className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                            ></i>
                        </li>
                    )}
                </React.Fragment>
            );
        };

        const renderDropdownOption = (option, index) => {
            if (option.isMulti) {
                let selectedOptions = [];
                option.options.forEach(
                    (value) =>
                        appliedFilters[option.name]
                            ?.map((item) => item.value)
                            .includes(value.value?.toString()) &&
                        selectedOptions.push(value.label)
                );

                if (!isEmpty(selectedOptions)) {
                    return (
                        <li
                            key={index}
                            className={`tags-items ${hideDateTag(
                                selectedFilters && selectedFilters[option.name]
                            )}`}
                        >
                            <span className="font-semibold mr-1">
                                {option.label}:
                            </span>
                            <span>{selectedOptions.join(", ")}</span>
                            <i
                                onClick={() => handleCloseTag(option.name)}
                                className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                            ></i>
                        </li>
                    );
                }
            } else {
                let optionName = option.options.find(
                    (value) =>
                        value.value?.toString() ===
                        appliedFilters[option.name].toString()
                )?.label;

                if (optionName) {
                    return (
                        <li
                            key={index}
                            className={`tags-items ${hideDateTag(
                                selectedFilters && selectedFilters[option.name]
                            )}`}
                        >
                            <span className="font-semibold mr-1">
                                {option.label}:
                            </span>
                            <span>{optionName}</span>
                            <i
                                onClick={() => handleCloseTag(option.name)}
                                className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                            ></i>
                        </li>
                    );
                }
            }
        };

        const renderCompareOption = (option, index) => {
            const appliedFilter = appliedFilters[option.name];
            return (
                <li
                    key={index}
                    className={`tags-items ${hideDateTag(
                        selectedFilters && selectedFilters[option.name]
                    )}`}
                >
                    <span className="font-semibold mr-1">
                        {appliedFilter.target}:
                    </span>
                    <span>
                        {t(appliedFilter.compare)} {appliedFilter.value}
                    </span>
                    <i
                        onClick={() => handleCloseTag(option.name)}
                        className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                    ></i>
                </li>
            );
        };

        const renderDefaultOptions = (option, index) => {
            return (
                <li
                    key={index}
                    className={`tags-items ${hideDateTag(
                        selectedFilters && selectedFilters[option.name]
                    )}`}
                >
                    <span className="font-semibold mr-1">{option.label}:</span>
                    <span>{appliedFilters[option.name]}</span>
                    <i
                        onClick={() => handleCloseTag(option.name)}
                        className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                    ></i>
                </li>
            );
        };

        const renderDoubleInputOption = (option, index) => {
            return option.fields.map((field, innerIndex) => {
                if (appliedFilters[option.name][field.name])
                    return (
                        <li
                            key={`${index}-${innerIndex}`}
                            className={`tags-items ${hideDateTag(
                                selectedFilters && selectedFilters[option.name]
                            )}`}
                        >
                            <span className="font-semibold mr-1">
                                {field.label}:
                            </span>
                            <span>
                                {appliedFilters[option.name][field.name]}
                            </span>
                            <i
                                onClick={() =>
                                    handleCloseTag(option.name, field.name)
                                }
                                className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                            ></i>
                        </li>
                    );
            });
        };

        return (
            filterOptions &&
            appliedFilters &&
            filterOptions.map((option, index) => {
                if (appliedFilters[option.name] !== undefined) {
                    switch (option.type) {
                        case "Date":
                            return renderDateOption(option, index);
                        case "Dropdown":
                            return renderDropdownOption(option, index);
                        case "Compare":
                            return renderCompareOption(option, index);
                        case "DoubleInput":
                            return renderDoubleInputOption(option, index);
                        default:
                            return renderDefaultOptions(option, index);
                    }
                }
            })
        );
    };
    return (
        <div className="product-privacy-info mx-1">
            <ul className="tags-wrapper flex items-center flex-wrap justify-end">
                {renderFilterTags()}
            </ul>
        </div>
    );
};

export default FilterTags;
